// src/utils/api.ts
export const handleApiError = (error: any) => {
    console.error('API Error:', error);
    return { errorMessage: '現在サービスのご利用できません。' };
};
